import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import Incidents from './Incidents';

export default withErrorBoundary(Incidents, 'Incidents');
